import React from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';

import { setMonthAndReload } from './filters_actions';
import connectWithStore from '../../../hocs/connectWithStore';

class MonthFilter extends React.Component {
  handleMonthChange = (selectedOption) => {
    this.props.setMonthAndReload(selectedOption);
  }

  render() {
    const { months } = this.props;

    const monthsOption = months.map((t) => ({value: t.value, label: t.label }));

    return (
      <li style={{width: '200px'}}>
        <Select className="select" onChange={this.handleMonthChange}
         options={monthsOption} defaultValue={monthsOption[0]} menuPortalTarget={document.body}  styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}/>
      </li>
    );
  }
}

MonthFilter.propTypes = {
  months: PropTypes.array.isRequired,
  monthSet: PropTypes.func,
};

const mapStateToProps = (state) => ({
  ...state.events,
  selectedMonth: state.events.selectedMonth,
});

const mapDispatchToProps = {
  setMonthAndReload,
};

export default connectWithStore(
  mapStateToProps,
  mapDispatchToProps,
)(MonthFilter);
